import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Tabber, TabItem } from '../../../designSystem/Tabber';
import { AdminTab } from './AdminTab';

type AdminSiteTabsProps =
{
    selectedAdminTab: 'overview' | 'sites' | 'organizations' | 'users' | 'globaltemplates' | 'articles' | 'profile',
    selectedSiteTab: 'siteOverview' | 'companyInfo' | 'deals' | 'notes',
    siteId?: string,
    orgId?: string
};

export function AdminSiteTabs (props: AdminSiteTabsProps): JSX.Element
{
    const navigate = useNavigate();

    function maybeAppendSiteIdToUrl (siteId: string): string
    {
        if(!siteId)
            return '';

        const searchParams = new URLSearchParams();
        searchParams.set('siteId', siteId);
        return `?${searchParams.toString()}`;
    }

    function handleTabChange (tab: typeof props.selectedSiteTab)
    {
        if (tab === 'siteOverview' && props.siteId)
            navigate(`/amorgy/sites/${props.siteId || ''}`);

        else if (tab === 'companyInfo' && props.orgId)
            navigate(`/amorgy/organizations/${props.orgId}/companyInfo${maybeAppendSiteIdToUrl(props.siteId || '')}`);

        else if (tab === 'deals')
            navigate(`/amorgy/organizations/${props.orgId}/deals${maybeAppendSiteIdToUrl(props.siteId || '')}`);
        else if (tab === 'notes')
            navigate(`/amorgy/organizations/${props.orgId}/notes${maybeAppendSiteIdToUrl(props.siteId || '')}`);

        else
            alert('unsupported tab selected: ' + tab);
    }

    const items:TabItem[] = [
        {
            tabName: 'siteOverview',
            text: 'Site',
            disabled: props.siteId === undefined
        },
        {
            tabName: 'companyInfo',
            text: 'Stamdata',
            disabled: props.orgId === undefined
        },
        {
            tabName: 'deals',
            text: 'Aftaler',
            disabled: props.orgId === undefined
        },
        {
            tabName: 'notes',
            text: 'Noter',
            disabled: props.orgId === undefined
        }
    ];

    return (
        
        <Flex flexDirection='column' gap={16}>
            
            <AdminTab selectedTab={props.selectedAdminTab} />

            
            <Tabber
                alignment='center'
                inline
                variant='text'
                onClick={(tabName) => handleTabChange(tabName as typeof props.selectedSiteTab)}
                selectedTabName={props.selectedSiteTab}
                items={items}
            />

        </Flex>
        
    );
}

type AdminSiteTabProps = {
    selectedSiteTab: 'siteOverview' | 'companyInfo' | 'deals' | 'notes',
    siteId?: string;
    orgId?: string;
};
export function AdminSiteTab(props: AdminSiteTabProps)
{
    const navigate = useNavigate();

    function maybeAppendSiteIdToUrl (siteId: string): string
    {
        if(!siteId)
            return '';

        const searchParams = new URLSearchParams();
        searchParams.set('siteId', siteId);
        return `?${searchParams.toString()}`;
    }

    function handleTabChange (tab: typeof props.selectedSiteTab)
    {
        if (tab === 'siteOverview' && props.siteId)
            navigate(`/amorgy/sites/${props.siteId || ''}`);

        else if (tab === 'companyInfo' && props.orgId)
            navigate(`/amorgy/organizations/${props.orgId}/companyInfo${maybeAppendSiteIdToUrl(props.siteId || '')}`);

        else if (tab === 'deals')
            navigate(`/amorgy/organizations/${props.orgId}/deals${maybeAppendSiteIdToUrl(props.siteId || '')}`);
        else if (tab === 'notes')
            navigate(`/amorgy/organizations/${props.orgId}/notes${maybeAppendSiteIdToUrl(props.siteId || '')}`);

        else
            alert('unsupported tab selected: ' + tab);
    }

    const items:TabItem[] = [
        {
            tabName: 'siteOverview',
            text: 'Site',
            disabled: props.siteId === undefined
        },
        {
            tabName: 'companyInfo',
            text: 'Stamdata',
            disabled: props.orgId === undefined
        },
        {
            tabName: 'deals',
            text: 'Aftaler',
            disabled: props.orgId === undefined
        },
        {
            tabName: 'notes',
            text: 'Noter',
            disabled: props.orgId === undefined
        }
    ];

    return (
        <Tabber
            alignment='center'
            inline
            variant='text'
            onClick={(tabName) => handleTabChange(tabName as typeof props.selectedSiteTab)}
            selectedTabName={props.selectedSiteTab}
            items={items}
        />
    )
}